var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";
import { useGetPermissions, useAllowedClientIds, useGetClientListPlatformQuery, getClientId, } from "../../store/api/core";
import { PermissionResource, PermissionResourceType, } from "../../store/api/permissions";
import { Box, styled } from "@mui/material";
import SpinnerAndErrorer from "../../components/SpinnerAndErrorer/SpinnerAndErrorer";
import PageNotFound from "../../components/PageNotFound";
var adminPortalOrigin = process.env.REACT_APP_ADMIN_PORTAL_URL;
var ClientIdEndpointCaller = function () {
    var _a, _b, _c, _d, _e, _f, _g;
    var clientId = "";
    var location = useLocation();
    var permissions = useGetPermissions();
    var referrer = localStorage.getItem("referrer");
    var allowedClientIds = useAllowedClientIds();
    var clientDetails = useGetClientListPlatformQuery({ navigatorUrl: referrer }, { shouldSkipCall: function () { return !referrer; } });
    if (!getClientId() &&
        allowedClientIds != null &&
        allowedClientIds.size != 1) {
        window.location.href = "".concat(adminPortalOrigin, "/clients");
        return null;
    }
    if (!getClientId() &&
        allowedClientIds != null &&
        allowedClientIds.size == 1) {
        clientId = (_a = allowedClientIds === null || allowedClientIds === void 0 ? void 0 : allowedClientIds.one) !== null && _a !== void 0 ? _a : "";
        var searchParams = new URLSearchParams(window.location.search);
        searchParams.set("client", clientId);
        var query = searchParams.toString();
        window.history.replaceState(window.history.state, "", "".concat(window.location.pathname).concat(query ? "?".concat(query) : "").concat(window.location.hash));
        return null;
    }
    if (!referrer && !clientId) {
        return (_jsx("div", __assign({ style: { textAlign: "center", marginTop: "30px" } }, { children: "Need referrer or client ID" })));
    }
    var LoaderContainer = styled(Box)({
        position: "fixed",
        display: "flex",
        flexDirection: "row",
        left: "calc(50% - 150px)",
        top: "50%",
    });
    if (!permissions ||
        clientDetails.isLoading ||
        !(((_b = clientDetails.data) === null || _b === void 0 ? void 0 : _b.data) && ((_c = clientDetails.data) === null || _c === void 0 ? void 0 : _c.data.length) > 0)) {
        return (_jsxs(LoaderContainer, { children: [" ", _jsx(SpinnerAndErrorer, { conditions: { spin: function () { return false; }, error: function () { return false; } } }), " "] }));
    }
    if (!clientId) {
        for (var _i = 0, permissions_1 = permissions; _i < permissions_1.length; _i++) {
            var permission = permissions_1[_i];
            if (permission.resourceName === PermissionResource.ORG_DASHBOARD_UI &&
                permission.resourceType === PermissionResourceType.Application &&
                ((_d = permission.clientIds) === null || _d === void 0 ? void 0 : _d.length) === 1 &&
                permission.clientIds[0] !== "*") {
                clientId = permission.clientIds[0];
            }
        }
    }
    if (!clientId) {
        if (((_e = clientDetails.data) === null || _e === void 0 ? void 0 : _e.data) && ((_f = clientDetails.data) === null || _f === void 0 ? void 0 : _f.data.length) === 1) {
            clientId = (_g = clientDetails.data) === null || _g === void 0 ? void 0 : _g.data[0].id;
        }
    }
    if (clientId) {
        localStorage.removeItem("referrer");
        var searchParams = new URLSearchParams(location.search);
        searchParams.set("client", clientId);
        return (_jsx(Navigate, { replace: true, to: {
                pathname: location.pathname,
                search: "?".concat(searchParams.toString()),
                hash: location.hash,
            } }));
    }
    else {
        // If we still don't have a client ID, we need to show an error and send the user
        // Admin Portal
        if (process.env.REACT_APP_ADMIN_PORTAL_URL) {
            window.location.href = "".concat(process.env.REACT_APP_ADMIN_PORTAL_URL);
        }
        return (_jsx(PageNotFound, { title: "Client not found", description: "Please contact your administrator to ensure you have access to the application." }));
    }
    return _jsx(Outlet, {});
};
export var RequiredClientId = function () {
    var location = useLocation();
    var params = useParams();
    var clientId = new URLSearchParams(location.search).get("client");
    if (clientId) {
        return _jsx(Outlet, {});
    }
    if (params.clientId) {
        var searchParams = new URLSearchParams(location.search);
        searchParams.set("client", params.clientId);
        return (_jsx(Navigate, { replace: true, to: {
                pathname: location.pathname,
                search: "?".concat(searchParams.toString()),
                hash: location.hash,
            } }));
    }
    return _jsx(ClientIdEndpointCaller, {});
};
